import { createSidecarMedium } from 'use-sidecar';
export var effectCar = createSidecarMedium();
export var focusHiddenMarker = 'data-focus-on-hidden';